import { Integration } from './integration';
import { IntegrationIdentifier } from './integration-identifier';

export class IntegrationInformation {

    constructor(i?: Integration, ii?: IntegrationIdentifier) {
        this.integrationId = i?.integrationId;
        this.destinationId = ii?.destinationId;
        this.destinationName = ii?.destinationName;
        this.identifierIdValue = ii?.identifierIdValue;
        this.identifierNameValue = ii?.identifierNameValue;
        this.identifierKeyValue = ii?.identifierKeyValue;
        this.identifierCreatedDate = ii?.createdDate;
        this.identifierUpdatedDate = ii?.updatedDate;
        this.canFastFetch = ii?.canFastFetch;
        this.canDataSwap = ii?.canDataSwap;
        this.subscriptionName = ii?.subscriptionName;
        this.isMABase = ii?.isMABase;
        this.isMABaseCustom = ii?.isMABaseCustom;
        this.clientId = i?.clientId;
        this.clientInformationId = i?.clientInformationId;
        this.clientName = i?.clientName;
        this.dataSourceType = i?.dataSourceTypeId;
        this.integrationName = i?.name;
        this.locked = i?.locked;
        this.lockReason = i?.lockReason;
        this.serverId = i?.serverId;
        this.errorRetentionDays = i?.errorRetentionDays;
        this.selfHosted = i?.selfHosted;
        this.integrationUpdatedDate = i?.updatedDate;
        this.integrationCreationDate = i?.initialCreationDate;
    }

    toIntegration = function (): Integration {
        return {
            clientId: this.clientId,
            clientInformationId: this.clientInformationId,
            clientName: this.clientName,
            dataSourceTypeId: this.dataSourceType,
            locked: this.locked,
            lockReason: this.lockReason,
            serverId: this.serverId,
            integrationId: this.integrationId,
            name: this.integrationName,
            ipRestricted: this.ipRestricted,
            errorRetentionDays: this.errorRetentionDays,
            selfHosted: this.selfHosted,
            updatedDate: this.integrationUpdatedDate,
            initialCreationDate: this.integrationCreationDate,
        };
    };

    toIdentifier(): IntegrationIdentifier {

        return {
            integrationId: this.integrationId,
            destinationId: this.destinationId,
            destinationName: this.destinationName,
            identifierIdValue: this.identifierIdValue,
            identifierNameValue: this.identifierNameValue,
            identifierKeyValue: this.identifierKeyValue,
            createdDate: this.identifierCreatedDate,
            updatedDate: this.identifierUpdatedDate,
            canFastFetch: this.canFastFetch,
            canDataSwap: this.canDataSwap,
            subscriptionName: this.subscriptionName,
            isMABase: this.isMABase,
            isMABaseCustom: this.isMABaseCustom,
        };
    }

    integrationId: string;
    destinationId: number;
    destinationName: string;
    identifierIdValue: string;
    identifierNameValue: string;
    identifierKeyValue: string;
    identifierCreatedDate: Date;
    identifierUpdatedDate: Date;
    canFastFetch: boolean;
    canDataSwap: boolean;
    subscriptionName: string;
    isMABase?: boolean;
    isMABaseCustom?: boolean;
    clientId: number;
    clientInformationId?: string;
    clientName: string;
    dataSourceType: string;
    integrationName: string;
    locked: boolean;
    lockReason: string;
    serverId: string;
    errorRetentionDays: number;
    selfHosted: boolean;
    integrationUpdatedDate: Date;
    integrationCreationDate: Date;
    losServerName: string;
    losUserName: string;
}
